/**
 * Single source of truth for CMS primary navigation: same parent targets as
 * `Mainmenu` sidebar sections, reused by the top navbar.
 */
const CMS_MAIN_NAV_ORDER = [
  "talents",
  "contests",
  "users",
  "posts",
  "settings",
];

const CMS_MAIN_NAV_SECTIONS = {
  talents: {
    label: "Talents",
    to: "/cms/talents",
    pathPrefixes: ["/cms/talents", "/cms/talent/", "/cms/usertalent"],
    visible: (ctx) => ctx.admin || ctx.editor,
    /** Sidebar only; keeps top bar light and avoids implying talent tree lives in navbar */
    topNav: true,
  },
  contests: {
    label: "Contests",
    to: "/cms/courses",
    pathPrefixes: [
      "/cms/courses",
      "/cms/course",
      "/cms/coursedetails",
      "/cms/coursedocuments",
      "/cms/ratings",
      "/cms/poll",
      "/cms/coursehist",
      "/cms/videogaller",
      "/cms/conteststats",
    ],
    visible: (ctx) => ctx.admin || ctx.editor,
  },
  users: {
    label: "Users",
    to: "/cms/users",
    pathPrefixes: [
      "/cms/users",
      "/cms/user",
      "/cms/juries",
      "/cms/jury",
      "/cms/audience",
      "/cms/editors",
      "/cms/editor",
      "/cms/administrator",
    ],
    visible: (ctx) => ctx.admin,
  },
  posts: {
    label: "Posts",
    to: "/cms/posts",
    pathPrefixes: ["/cms/posts", "/cms/post", "/cms/categories"],
    visible: () => true,
  },
  settings: {
    label: "Setting",
    to: "/cms/settings",
    pathPrefixes: [
      "/cms/settings",
      "/cms/about",
      "/cms/notifications",
      "/cms/language",
      "/cms/languages",
      "/cms/country",
      "/cms/countries",
      "/cms/cities",
      "/cms/faq",
      "/cms/videogallerylist",
      "/cms/videogallery",
      "/cms/popupmessage",
      "/cms/banned",
      "/cms/testimonial",
      "/cms/pages",
      "/cms/page",
    ],
    visible: (ctx) => ctx.admin || ctx.editor,
  },
};

export function getCmsMainNavSection(key) {
  return CMS_MAIN_NAV_SECTIONS[key];
}

export function getVisibleCmsMainNavItems(isAdminUser, isEditorUser) {
  const ctx = { admin: isAdminUser, editor: isEditorUser };
  return CMS_MAIN_NAV_ORDER.filter((key) =>
    CMS_MAIN_NAV_SECTIONS[key].visible(ctx)
  ).map((key) => ({
    key,
    label: CMS_MAIN_NAV_SECTIONS[key].label,
    to: CMS_MAIN_NAV_SECTIONS[key].to,
    pathPrefixes: CMS_MAIN_NAV_SECTIONS[key].pathPrefixes,
  }));
}

/** Primary links shown in `Navbar` (excludes sections with `topNav: false`). */
export function getVisibleCmsTopNavItems(isAdminUser, isEditorUser) {
  const ctx = { admin: isAdminUser, editor: isEditorUser };
  return CMS_MAIN_NAV_ORDER.filter((key) => {
    const s = CMS_MAIN_NAV_SECTIONS[key];
    if (s.topNav === false) return false;
    return s.visible(ctx);
  }).map((key) => ({
    key,
    label: CMS_MAIN_NAV_SECTIONS[key].label,
    to: CMS_MAIN_NAV_SECTIONS[key].to,
    pathPrefixes: CMS_MAIN_NAV_SECTIONS[key].pathPrefixes,
  }));
}

export function isCmsMainNavSectionActive(pathname, section) {
  if (!pathname || !section) return false;
  if (pathname === section.to) return true;
  return section.pathPrefixes.some((p) => pathname.startsWith(p));
}
